// Querys and Mutations
import {
  CREATE,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE,
  GET_ALL,
  GENERATE,
  LOAD_MASSIVE,
  GET_BOND_CONTROL_MASSIVE_WITH_PAGINATION,
  DELETE_MASSIVE
} from '@/graphql/dailyControl/BondControlGraphQl'

// models
import { ResponseDefault, Paginator, ResponseCustom } from '@/models'
import {
  BondControl,
  BondControlForm,
  BondControlWithPagination,
  FiltersBondControl,
  FiltersBondControlList,
  BondControlGenerate,
  BondControlMassiveWithPagination,
  BondControlMassive
} from '@/models/dailyControl'

// apollo
import { apolloClient } from '@/apollo'
import { getFirstErrorApollo } from '@/utils/apollo'

class BondControlService {
  /**
   * Queries
   */
  async getWithPagination (perPage = 10, page = 1, filters: FiltersBondControl): Promise<BondControlWithPagination> {
    const result = await apolloClient.query({
      query: GET_WITH_PAGINATION,
      variables: {
        page: page,
        perPage: perPage,
        filters: {
          ...filters
        }
      }
    })
    const pagination: Paginator = result.data.bondControlWithPagination.paginatorInfo
    const data: BondControl[] = result.data.bondControlWithPagination.data
    const response: BondControlWithPagination = {
      objects: data,
      pagination: pagination
    }
    return response
  }

  async getMassiveWithPagination (perPage = 10, page = 1, filters: FiltersBondControlList): Promise<BondControlMassiveWithPagination> {
    const result = await apolloClient.query({
      query: GET_BOND_CONTROL_MASSIVE_WITH_PAGINATION,
      variables: {
        page: page,
        first: perPage,
        filters: {
          ...filters
        }
      }
    })
    const pagination: Paginator = result.data.bondControlMassiveWithPagination.pagination
    const data: BondControlMassive[] = result.data.bondControlMassiveWithPagination.data
    const response: BondControlMassiveWithPagination = {
      objects: data,
      pagination: pagination
    }
    return response
  }

  async getAll (filters: FiltersBondControl): Promise<BondControl[]> {
    const result = await apolloClient.query({
        query: GET_ALL,
        variables: {
          filters
        }
    })
    return result.data.bondControls
  }

  async generate (filters: FiltersBondControl): Promise<BondControlGenerate[]> {
    const result = await apolloClient.query({
        query: GENERATE,
        variables: {
          filters
        }
    })
    return result.data.bondControlGenerate
  }

  /**
   * Mutations
   */
  create (form: BondControlForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
      mutation: CREATE,
      variables: {
        input: form
      }
    }).then(() => {
      return {
        success: true,
        msg: 'success'
      }
    }).catch(e => {
      throw getFirstErrorApollo(e)
    })
  }

  update (id: number, form: BondControlForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
      mutation: UPDATE,
      variables: {
        id: id,
        input: form
      }
    }).then(() => {
      return {
        success: true,
        msg: 'success'
      }
    }).catch(e => {
      throw getFirstErrorApollo(e)
    })
  }

  saveMassive (form: BondControlForm[]): Promise<ResponseCustom> {
    return apolloClient.mutate({
      mutation: LOAD_MASSIVE,
      variables: {
        input: form
      }
    }).then(() => {
      return {
        success: true,
        msg: 'success'
      }
    }).catch(e => {
      throw getFirstErrorApollo(e)
    })
  }

  async delete (id: number): Promise<ResponseDefault> {
    await apolloClient.mutate({
      mutation: DELETE,
      variables: {
        id: id
      }
    })
    return {
      success: true,
      errors: []
    }
  }

  async deleteMassive (headquarter: number, area: number, sub_area: number, fortnight: number, year: number, month: number, loaded_massive: boolean): Promise<ResponseDefault> {
    await apolloClient.mutate({
      mutation: DELETE_MASSIVE,
      variables: {
        headquarter,
        area,
        sub_area,
        fortnight,
        year,
        month,
        loaded_massive
      }
    })
    return {
      success: true,
      errors: []
    }
  }
}

export default new BondControlService()
